<div class="flex w-full flex-col">
  <div class="flex h-2 flex-grow flex-col overflow-y-auto">
    <ng-scrollbar
      [orientation]="'vertical'"
      [visibility]="'hover'"
      [appearance]="'compact'"
    >
      <div class="h-[16px]"></div>

      <tree-root
        class="h-2 w-full"
        #itemsTree
        [nodes]="metricNodes"
        [options]="treeOptions"
        (initialized)="treeOnInitialized()"
        (updateData)="treeOnUpdateData()"
      >
        <ng-template #treeNodeTemplate let-node="node">
          <div
            class="group-bar flex w-full flex-row pr-5"
            [ngClass]="{
              'h-[60px] pl-3': node.data.isField === false,
              'h-11 pl-8': node.data.isField === true
            }"
          >
            <div
              data-cy="metricsTreeItem"
              class="hover:bg-m50 flex w-full cursor-pointer select-none flex-row rounded pr-5"
              [ngClass]="{
                'pl-6': node.data.isField === true,
                'pl-2': node.data.isField === false
              }"
              (click)="nodeOnClick(node)"
            >
              <div class="relative flex w-full flex-row items-center">
                <div class="flex min-w-[2px] flex-row items-center">
                  <div
                    *ngIf="node.data.isField === false"
                    class="flex flex-row items-center space-x-1"
                  >
                    <div class="flex items-center">
                      <m-chevron-right-icon
                        *ngIf="!node.isExpanded && node.hasChildren"
                      ></m-chevron-right-icon>

                      <m-chevron-down-icon
                        *ngIf="node.isExpanded && node.hasChildren"
                      ></m-chevron-down-icon>
                    </div>
                  </div>

                  <div
                    *ngIf="node.data.isField === true"
                    class="text-g1 flex h-6 w-6 flex-shrink-0 items-center justify-center"
                  >
                    <m-field-result
                      [fieldClass]="nodeClassMeasure"
                      [result]="node.data.fieldResult"
                      [size]="2"
                    ></m-field-result>
                  </div>

                  <div class="text-s1 ml-0 flex-grow truncate">
                    <div class="flex flex-col">
                      <div class="flex">
                        <!-- <span
                      [ngClass]="{
                        'ml-3': node.hasChildren === true,
                        'ml-2': node.hasChildren === false
                      }"
                    ></span> -->
                        <span class="ml-3 truncate text-base">
                          <span *ngIf="node.data.isField === true">
                            <span>{{ node.data.metric.partNodeLabel }}</span>

                            <span class="ml-2 font-semibold">{{
                              node.data.metric.partFieldLabel
                            }}</span>
                          </span>

                          <span *ngIf="node.data.isField === false" class="">
                            <span class="">{{ node.data.topLabel }}</span>
                          </span>
                        </span>
                      </div>

                      <div class="flex" *ngIf="node.data.isField === false">
                        <span class="truncate text-base">
                          <span class="">
                            <span class="text-s400 ml-3"
                              >by {{ node.data.timeLabel }}</span
                            >
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex flex-grow"></div>

                <div
                  *ngIf="node.data.isField === true"
                  class="invisible ml-3 flex [.group-bar:hover_&]:visible"
                >
                  <m-field-options
                    [metricNodeData]="node.data"
                    [isMetric]="true"
                  ></m-field-options>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </tree-root>
    </ng-scrollbar>
  </div>
</div>

<!-- <div *ngIf="uiQuery$ | async"></div> -->
<div *ngIf="metricNodes$ | async"></div>
